import axios from "axios";
import { API_URL } from "./const";
import { getAttribution } from "../util/attribution";

interface ContactFormData {
  companyName: string;
  fullName: string;
  email: string;
  phone: string;
  message: string;
}

class ContactService {
  /**
   * Submit a contact/demo request, enriched with the session's first-touch
   * attribution (landing path, referrer, UTM, gclid) so the lead record
   * carries its source. The extra fields are optional for the backend -
   * Spring's default Jackson config ignores unknown JSON properties, so this
   * is safe to send even before the backend persists them.
   */
  submitContactForm(formData: ContactFormData) {
    const attribution = getAttribution();
    return axios.post(API_URL + "contact", { ...formData, ...attribution });
  }
}

const contactService = new ContactService();
export default contactService;
